import styled from 'styled-components';

const StyledSpanContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: row;
	width: 100%;
	height: 14px;
	padding: 0 4px;

	span {
		font-family: 'GT Walsheim Pro';
		font-size: 10px;
		opacity: 0.75;
		user-select: none;
	}
`;

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

const StyledContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export { StyledContainer, StyledSpanContainer, StyledContentContainer };
